module.exports = __webpack_public_path__ + "static/media/arrowLeftNew.2b5e73a3.svg";